(() => {
  'use strict';
  /* Cart drawer helpers: BIENVENUE15 one-click hint, free-shipping trust line, smooth #achat links. */
  const root = window.Shopify?.routes?.root || window.KALIE_CONFIG?.root || '/';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const WELCOME = 'BIENVENUE15';
  const read = key => { try { return sessionStorage.getItem(key) || ''; } catch { return ''; } };
  const canonical = code => String(code || '').trim().toUpperCase();
  let cart = null;

  function welcomeApplied() {
    if (canonical(read('kalie_applied_code')) === WELCOME) return true;
    return (cart?.discount_codes || []).some(d => canonical(d.code) === WELCOME);
  }
  function renderHint() {
    const copied = canonical(read('kalie_promo_code')) === WELCOME;
    const hasItems = Number(cart?.item_count || 0) > 0;
    document.querySelectorAll('[data-kalie-promo-hint]').forEach(hint => {
      hint.hidden = !copied || !hasItems || welcomeApplied();
    });
  }
  function renderTrust() {
    document.querySelectorAll('[data-kalie-cart-trust]').forEach(line => {
      const threshold = Number(line.dataset.threshold || 0);
      const below = cart && Number(cart.item_count) > 0 && Number(cart.total_price) < threshold;
      const next = below ? line.dataset.below : line.dataset.free;
      if (next && line.textContent !== next) line.textContent = next;
    });
  }
  function render(data) {
    if (data && Array.isArray(data.items)) cart = data;
    renderHint();
    renderTrust();
  }

  document.addEventListener('kalie:cart', event => render(event.detail?.cart));
  document.addEventListener('click', event => {
    const apply = event.target.closest('[data-kalie-promo-hint-apply]');
    if (apply) {
      const scope = apply.closest('[data-kalie-promo]') || document;
      const form = scope.querySelector('[data-kalie-promo-form]');
      const input = form?.querySelector('[data-kalie-promo-input]');
      if (!form || !input) return;
      input.value = WELCOME;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      return;
    }
    const link = event.target.closest('a[href="#achat"]');
    if (link) {
      const target = document.getElementById('achat');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      if (target.hasAttribute('tabindex')) target.focus({ preventScroll: true });
    }
  });

  fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(response => (response.ok ? response.json() : null))
    .then(render)
    .catch(() => render(null));
})();
